export interface INotificationPreference {

    id?: number;
   
}

export class NotificationPreference implements INotificationPreference {
    constructor(
        public id?: number,
    ) {
        
    }
}